import { IconContainerProps } from '@utilitywarehouse/hearth-react';
import {
  BroadbandSmallIcon,
  ElectricitySmallIcon,
  InsuranceSmallIcon,
  MobileSmallIcon,
} from '@utilitywarehouse/hearth-react-icons';
import { ReactNode } from 'react';

import {
  TIERS,
  TIER_SERVICES,
  Tier,
} from '@components/WelcomeBonusSection/tiers';
import { ProductType } from '@generated/gql/graphql';

export enum IconState {
  IDLE = 'IDLE',
  REMAINING = 'REMAINING',
  SELECTED = 'SELECTED',
}

export type Product = {
  type: ProductType;
  Icon: ReactNode;
  colorScheme: IconContainerProps['colorScheme'];
};

type TierServiceState =
  | {
      type: IconState.IDLE;
    }
  | {
      type: IconState.REMAINING;
      remainingProducts: Product[];
    }
  | {
      type: IconState.SELECTED;
      selectedProducts: Product[];
    };

const PRODUCTS: Product[] = [
  {
    type: ProductType.Broadband,
    colorScheme: 'broadband',
    Icon: <BroadbandSmallIcon />,
  },
  {
    type: ProductType.Energy,
    colorScheme: 'energy',
    Icon: <ElectricitySmallIcon />,
  },
  {
    type: ProductType.Insurance,
    colorScheme: 'insurance',
    Icon: <InsuranceSmallIcon />,
  },
  {
    type: ProductType.Mobile,
    colorScheme: 'mobile',
    Icon: <MobileSmallIcon />,
  },
];

const isFirstTierAndHasNoSelections = (tier: Tier, countOfProducts: number) =>
  tier.count === TIERS?.[0].count && countOfProducts === 0;

export const getTierServiceState = (
  tier: Tier,
  productType: ProductType[]
): TierServiceState => {
  if (
    tier.count === productType.length + 1 ||
    isFirstTierAndHasNoSelections(tier, productType.length)
  ) {
    return {
      type: IconState.REMAINING,
      remainingProducts: TIER_SERVICES.reduce<Product[]>((acc, tierService) => {
        if (productType.includes(tierService)) {
          return acc;
        }

        const found = PRODUCTS.find(
          (productState) => productState.type === tierService
        );

        if (found) {
          acc.push(found);
        }

        return acc;
      }, []),
    };
  }

  if (productType.length >= tier.count) {
    const selectedTierServices = productType.slice(0, tier.count);

    return {
      type: IconState.SELECTED,
      selectedProducts: selectedTierServices.reduce<Product[]>(
        (acc, selectedTierService) => {
          const found = PRODUCTS.find(
            (productState) => productState.type === selectedTierService
          );

          if (found) {
            acc.push(found);
          }

          return acc;
        },
        []
      ),
    };
  }

  return {
    type: IconState.IDLE,
  };
};
